// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "fdd47866" + "." + "2b15daf4f4b79353" + ".js";
};